export default function ChatSmileIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M2.08204 8.00016C2.08204 4.31816 5.0667 1.3335 8.7487 1.3335C12.4307 1.3335 15.4154 4.31816 15.4154 8.00016C15.4154 11.6822 12.4307 14.6668 8.7487 14.6668H2.08204L4.0347 12.7142C3.41473 12.0958 2.92306 11.361 2.58796 10.552C2.25285 9.74304 2.08092 8.8758 2.08204 8.00016ZM5.3007 13.3335H8.7487C9.80354 13.3335 10.8347 13.0207 11.7117 12.4347C12.5888 11.8486 13.2724 11.0157 13.6761 10.0411C14.0797 9.0666 14.1853 7.99425 13.9796 6.95968C13.7738 5.92512 13.2658 4.97481 12.5199 4.22893C11.7741 3.48305 10.8237 2.9751 9.78918 2.76931C8.75462 2.56352 7.68226 2.66914 6.70773 3.07281C5.73319 3.47647 4.90023 4.16006 4.3142 5.03712C3.72816 5.91418 3.41537 6.94533 3.41537 8.00016C3.41537 9.43483 3.9827 10.7768 4.97737 11.7715L5.92004 12.7142L5.3007 13.3335ZM6.08204 8.66683H11.4154C11.4154 9.37407 11.1344 10.0524 10.6343 10.5524C10.1342 11.0525 9.45595 11.3335 8.7487 11.3335C8.04146 11.3335 7.36318 11.0525 6.86308 10.5524C6.36299 10.0524 6.08204 9.37407 6.08204 8.66683Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
